import styled from 'styled-components'

export const Container = styled.div`
  .MuiFormControl-marginNormal {
    justify-content: center;

    margin-top: 0px;
    margin-bottom: 0px;

    background: #0d3549;

    height: 36px;

    width: 150px;

    border-radius: 70px;

    margin: 0px 10px;
  }

  .MuiInputBase-root {
    color: white;
    font-size: 11px;
  }

  .MuiInput-underline:before {
    border-bottom: none;
  }

  .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: none;
  }

  .MuiInput-underline:after {
    border-bottom: none;
  }

  .MuiInputBase-input {
    text-align: center;
  }
`
